module.exports = __webpack_public_path__ + "static/media/img-giveaway.60fb960e.png";